<template>
  <v-chart class="chart" :option="option" />
</template>

<script>
import { getResourceTypeDateView } from "@/api/comd.js";
export default {
  data() {
    return {
      option: {
        tooltip: {
          trigger: "item",
        },
        visualMap: {
          show: false,
          min: 80,
          max: 600,
          inRange: {
            colorLightness: [0, 1],
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: [20, 100],
            center: ["50%", "50%"],
            data: [
              { value: 435, name: "文件资源" },
              { value: 310, name: "视频资源" },
              { value: 274, name: "压缩包资源" },
              { value: 235, name: "音乐资源" },
              { value: 400, name: "模型资源" },
              { value: 300, name: "图片资源" },
            ].sort(function (a, b) {
              return a.value - b.value;
            }),
            roseType: "radius",
            label: {
              color: "rgba(255, 255, 255, 1)",
              fontSize: 14,
              formatter: ["{dot|●}  {name|{b}}", "{blank|}{percent|{d}%}"].join(
                "\n"
              ),
              // formatter: (params) => {
              //   return '{dot|●}  {name|'+ params.name+'}'
              // },
              rich: {
                dot: {
                  color: "rgb(56, 202, 251)",
                  fontSize: 20,
                },
                percent: {
                  color: "#38CAFB",
                  align: "left",
                },
                name: {
                  color: "#BAC3C4",
                },
                blank: {
                  width: 20,
                },
              },
            },
            labelLine: {
              lineStyle: {
                color: "rgb(56, 202, 251)",
              },
              smooth: 0.2,
              length: 10,
              length2: 20,
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function (idx) {
              return Math.random() * 200;
            },
          },
        ],
      },
      dataview: [
        {
          value: 435,
          name: "文件资源",
          itemStyle: { normal: { color: "#7FAE90" } },
        },
        {
          value: 310,
          name: "视频资源",
          itemStyle: { normal: { color: "#7FAE90" } },
        },
        {
          value: 274,
          name: "压缩包资源",
          itemStyle: { normal: { color: "#7FAE90" } },
        },
        {
          value: 235,
          name: "音乐资源",
          itemStyle: { normal: { color: "#7FAE90" } },
        },
        {
          value: 400,
          name: "模型资源",
          itemStyle: { normal: { color: "#7FAE90" } },
        },
        {
          value: 300,
          name: "图片资源",
          itemStyle: { normal: { color: "#7FAE90" } },
        },
      ],
    };
  },
  created() {
    this.getResourceTypeDateViewHandel();

  },
  methods: {
    async getResourceTypeDateViewHandel() {
      let res = await getResourceTypeDateView();
      let i = 0;
      this.dataview = res.data.map((en) => {
        let col = this.getColor(i);
        i++;
        return {
          name: en.typeName,
          value: en.rate,
          itemStyle: { normal: { color: col ? col : this.createColorCode() } },
        };
      });
      this.option = {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: [20, 100],
            center: ["50%", "50%"],
            data: this.dataview.sort(function (a, b) {
              return a.value - b.value;
            }),
            roseType: "radius",
            label: {
              color: "rgba(255, 255, 255, 1)",
              fontSize: 14,
              formatter: ["{dot|●}  {name|{b}}", "{blank|}{percent|{d}%}"].join(
                "\n"
              ),
              // formatter: (params) => {
              //   return '{dot|●}  {name|'+ params.name+'}'
              // },
              rich: {
                dot: {
                  color: "rgb(56, 202, 251)",
                  fontSize: 20,
                },
                percent: {
                  color: "#38CAFB",
                  align: "left",
                },
                name: {
                  color: "#BAC3C4",
                },
                blank: {
                  width: 20,
                },
              },
            },
            labelLine: {
              lineStyle: {
                color: "rgb(56, 202, 251)",
              },
              smooth: 0.2,
              length: 10,
              length2: 20,
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function (idx) {
              return Math.random() * 200;
            },
          },
        ],
      };
    },
    //生成不同的颜色代码
    createColorCode() {
      return (
        "rgb(" +
        [
          Math.round(Math.random() * 160),
          Math.round(Math.random() * 160),
          Math.round(Math.random() * 160),
        ].join(",") +
        ")"
      );
    },
    getColor(index) {
      var colorArr = [
        "#488CF7",
        "#036FEE",
        "#29A4EC",
        "#4ADFCB",
        "#4CAFF9",
        "#38CAFB",
      ];
      return colorArr[index];
    },
  },
};
</script>

<style scoped>
</style>